import type { Profile, EventCategory, ProfileType, TourStopWithDetails } from "@/lib/data/types";

export const EVENT_CATEGORIES: {
  id: EventCategory;
  label: string;
  description: string;
  href: string;
  accent: string;
}[] = [
  {
    id: "music",
    label: "Music",
    description: "Concerts, festivals, and live performances",
    href: "/music",
    accent: "var(--gold)",
  },
  {
    id: "sports",
    label: "Sports",
    description: "Races, matches, and athlete appearances",
    href: "/sports",
    accent: "var(--green)",
  },
  {
    id: "culture",
    label: "Culture",
    description: "Film, art, food, and heritage gatherings",
    href: "/culture",
    accent: "var(--red-soft)",
  },
  {
    id: "community",
    label: "Community",
    description: "Conferences, fundraisers, and local gatherings",
    href: "/community",
    accent: "var(--sky)",
  },
];

export const CATEGORY_BY_ID = Object.fromEntries(
  EVENT_CATEGORIES.map((category) => [category.id, category])
) as Record<EventCategory, (typeof EVENT_CATEGORIES)[number]>;

export const PROFILE_TYPE_LABELS: Record<ProfileType, string> = {
  artist: "Artist",
  athlete: "Athlete",
  organization: "Organization",
  speaker: "Speaker",
};

export function profileHref(profile: Profile) {
  return `/profiles/${profile.slug}`;
}

export function eventEndTime(stop: TourStopWithDetails) {
  return new Date(stop.endDateTime ?? stop.dateTime).getTime();
}

export function isUpcomingEvent(stop: TourStopWithDetails, now = Date.now()) {
  return (
    stop.published !== false &&
    stop.status !== "past" &&
    stop.status !== "cancelled" &&
    eventEndTime(stop) >= now
  );
}
